import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import TagAudienceCount from "../model/TagAudienceCount";

const AudienceSizeApiService = async (
  request: number[]
): Promise<TagAudienceCount> => {
  const url = `/employertag/audience-size/`;
  const { data } = await axios.post(url, { tags: request });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useAudienceSizeApiService = (request: number[]) =>
  useQuery<Promise<TagAudienceCount>, AxiosError, TagAudienceCount>(
    ["AudienceSizeApiService", ...request],
    () => AudienceSizeApiService(request)
  );

export default useAudienceSizeApiService;
